// noinspection JSUnusedGlobalSymbols

import Date from '../../../client/date.js'
import Form from '../../../client/form.js'
import Image from '../../../client/image.js'
import Network from '../../../client/network.js'
import Tab from '../../../client/tab.js'
import Table from '../../../client/table.js'
import Tooltip from '../../../client/tooltip.js'

export default class
{
	static init()
	{
		$(() =>
		{
			Date.init()
			Form.init()
			Image.init()
			Network.init()
			Tab.init()
			Table.init()
			Tooltip.init()
		})
	}

	static staff(staff, type)
	{
		document.cookie = `staff_${type}=${staff}; path=/; max-age=${86400 * 365}`
		location.reload()
	}

	static language(language)
	{
		document.cookie = `language=${language}; path=/; max-age=${86400 * 365}`
		location.reload()
	}

	static modal_open(id, event = undefined)
	{
		if(event) event.stopPropagation()

		$(`[data-remodal-id=${id}]`).remodal({
			hashTracking: false,
		}).open()
	}

	static modal_close(id, event)
	{
		if(event) event.stopPropagation()

		$(`[data-remodal-id=${id}]`).remodal({
			hashTracking: false,
		}).close()
	}
}
